(function () {
  const VIDEO_SOURCES = {
    TGG: [
      {
        title: "Jeep JL Wrangler",
        src: "https://cdn.shopify.com/videos/c/o/v/f94468034721439cb32b6670161fe6cc.mp4",
      },
      {
        title: "Dodge Charger",
        src: "https://cdn.shopify.com/videos/c/o/v/e1724e74e2b04532bc02abb2a0cd32d7.mp4",
      },
      {
        title: "Jeep Gladiator",
        src: "https://cdn.shopify.com/videos/c/o/v/8edbdfe547414aed85d1b6042ddae942.mp4",
      },
      {
        title: "Dodge Charger",
        src: "https://cdn.shopify.com/videos/c/o/v/b41c703664cd417c9d2f8faedb26d8f4.mp4",
      },
      {
        title: "Toyota 4 Runner",
        src: "https://cdn.shopify.com/videos/c/o/v/5a964c6f668842c48d8069da92ca97e6.mp4",
      },
      {
        title: "Chevrolet Camaro",
        src: "https://cdn.shopify.com/videos/c/o/v/d90062d5c79b4c2ab8a61145e31dc722.mp4",
      },
      {
        title: "Ford Mustang",
        src: "https://cdn.shopify.com/videos/c/o/v/775b4a20f47f4b0e93f1c9b54419b53a.mp4",
      },
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/ecd9b1b543c04f598907e6cc9e376955.mp4",
      },
    ], // TWO GUYS GARAGE
    AGG: [
      {
        title: "Jeep",
        src: "https://cdn.shopify.com/videos/c/o/v/0955df33e53e410eae4b2bae46c2bc60.mp4",
      },
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/b44a781321e746e3b17234e8bfff0774.mp4",
      },
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/1c67a73293c24c51917f40161c6562f3.mp4",
      },
    ], // ALL GIRLS GARAGE
    TU: [
      {
        title: "Ford Bronco",
        src: "https://cdn.shopify.com/videos/c/o/v/7af49477cfb945959a103d98c71ae939.mp4",
      },
      {
        title: "Ford F250",
        src: "https://cdn.shopify.com/videos/c/o/v/09fd8fed6dca4cfcb2d953c12acf110d.mp4",
      },
      {
        title: "Ford Maverick",
        src: "https://cdn.shopify.com/videos/c/o/v/5b06e25db9234c81a23a78646f686580.mp4",
      },
      {
        title: "Toyota 4 Runner",
        src: "https://cdn.shopify.com/videos/c/o/v/b3bd23aa6bc142aba84c8d8d1016d7d7.mp4",
      },
      {
        title: "Toyota Tundra",
        src: "https://cdn.shopify.com/videos/c/o/v/87bfccd5cfcd4d4bbf702ab23332029d.mp4",
      },
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/2cce6978da5c494daa2af877e27cbbe8.mp4",
      },
      {
        title: "Jeep JK",
        src: "https://cdn.shopify.com/videos/c/o/v/0573b8abcc8a4bcab5cba1f2df398fa9.mp4",
      },
    ], // TRUCKU
    FW: [
      {
        title: "Ford Bronco",
        src: "https://cdn.shopify.com/videos/c/o/v/945cff9a53564b549aa3e8543dd18f71.mp4",
      },
      {
        title: "Chevy Silverado",
        src: "https://cdn.shopify.com/videos/c/o/v/ade30e8ba1cb4617b0c30661552a5a8a.mp4",
      },
      {
        title: "Toyota FJ Cruiser",
        src: "https://cdn.shopify.com/videos/c/o/v/8d1cfcff2b6344c3936646da033290fd.mp4",
      },
    ], // FOUR WHEELER
    CF: [
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/97d26f77ff674f7b8368bdcfd2e7f61f.mp4",
      },
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/c432a9d96e0b4ee290137c54b2d2bc33.mp4",
      },
    ], // CARFIX
    DM: [
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/3b40850775b84a2684da732ef7acd8b8.mp4",
      },
    ], // DETROIT MUSCLE
    BFO: [
      {
        title: "Build for Offroad",
        src: "https://cdn.shopify.com/videos/c/o/v/4c6a4af6d49949779fb25a75fa374b33.mp4",
      },
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/adafd2e225234e789688788ba6930697.mp4",
      },
      {
        title: "Pedal Commander for You",
        src: "https://cdn.shopify.com/videos/c/o/v/de7cacd764ad4275a6628ba15882e94c.mp4",
      }
    ], // BUILD FOR OFFROAD
  };
  let targetChannel = "";
  const modalOpeners = document.querySelectorAll(
    "a[data-role='open-videos-modal']"
  );
  const modalContainer = document.querySelector(
    "div[data-role='videos-modal']"
  );

  const modalNavs = document.querySelectorAll(".videos-modal--nav-item");

  const videoElement = modalContainer.querySelector("video");
  const modalTitle = document.querySelector(".videos-modal--title");

  modalOpeners.forEach((link) => {
    link.addEventListener("click", () => {
      console.log("video opened --->");
      targetChannel = link.dataset.target;
      if (!targetChannel) return;
      const videos = VIDEO_SOURCES[targetChannel];
      changeVideo({
        src: videos[0].src,
        totalLength: videos.length,
        currentIdx: 1,
      });
      changeModalVisibility("open");
    });
  });

  modalContainer.addEventListener("click", (e) => {
    if (
      e.target.dataset.role === "videos-modal" ||
      e.target.dataset.role === "close-modal"
    ) {
      changeModalVisibility("close");
    }
  });

  modalNavs.forEach((item) => {
    item.addEventListener("click", handleModalNavClick);
  });

  function handleModalNavClick(e) {
    const currentVideo = videoElement.src;
    const videos = VIDEO_SOURCES[targetChannel];

    if (e.currentTarget.dataset.role === "next") {
      const nextIndex = getNextIndex(currentVideo, videos);
      changeVideo({
        src: videos[nextIndex].src,
        totalLength: videos.length,
        currentIdx: nextIndex + 1,
      });
      return;
    }
    if (e.currentTarget.dataset.role === "prev") {
      const prevIndex = getPrevIndex(currentVideo, videos);
      changeVideo({
        src: videos[prevIndex].src,
        totalLength: videos.length,
        currentIdx: prevIndex + 1,
      });

      return;
    }
  }

  const TRANSITION_DURATION =
    parseFloat(getComputedStyle(modalContainer).transitionDuration) * 1000;
  let isModalAnimating = false;
  function changeModalVisibility(targetState) {
    if (isModalAnimating) return;
    if (targetState === "open") {
      isModalAnimating = true;
      document.body.style.overflow = "hidden";
      modalContainer.classList.remove("hidden");
      setTimeout(() => {
        modalContainer.classList.remove("invisible");
      }, 0);
      setTimeout(() => {
        isModalAnimating = false;
      }, TRANSITION_DURATION);
      return;
    }
    if (targetState === "close") {
      isModalAnimating = true;
      videoElement.src = "";
      document.body.style.overflow = "";
      modalContainer.classList.add("invisible");
      setTimeout(() => {
        modalContainer.classList.add("hidden");
        isModalAnimating = false;
      }, TRANSITION_DURATION);
      return;
    }
    throw new Error(`unhandled modal state:${targetState}`);
  }

  function getNextIndex(currentSrc, array) {
    let currentIndex = array.findIndex((item) => item.src === currentSrc);
    return (currentIndex + 1) % array.length;
  }

  function getPrevIndex(currentSrc, array) {
    let currentIndex = array.findIndex((item) => item.src === currentSrc);
    if (currentIndex === 0) return array.length - 1;
    return currentIndex - 1;
  }

  function changeVideo({ src, totalLength, currentIdx }) {
    videoElement.src = src;
    modalTitle.innerHTML = `${currentIdx}/${totalLength}`;
  }
})();
